<template>
  <div class="flex flex-row items-center bg-PRIMARY rounded-lg">
      <slot name="content"> </slot>
  </div>
</template>

<script setup></script>
